import { render, staticRenderFns } from "./segmented-progress-bar.vue?vue&type=template&id=3155a37a"
import script from "./segmented-progress-bar.vue?vue&type=script&lang=js"
export * from "./segmented-progress-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports